const SETTING = {
  SWAP_SETTING: {
    DEFAULT_SLIPPAGE: 0.5,
    MIN_SLIPPAGE: 0,
    MAX_SLIPPAGE: 30,
  },
};

export default SETTING;
